import React from 'react'
import styled from 'styled-components'
import { Radio as AntRadio } from 'antd'
import { RadioProps as AntRadioProps } from 'antd/lib/radio'

import { Color, ThemeWrapper } from '../theme'

export const RadioGroup = AntRadio.Group

export interface RadioProps extends React.PropsWithChildren<AntRadioProps> {
  color?: Color
  variant?: Color
}

const StyledRadio = styled(AntRadio)<RadioProps>`
  color: ${({ color, theme }) => theme.colors[color || 'primary']};

  & .ant-radio {
    vertical-align: middle;

    .ant-radio-inner {
      border-color: ${({ theme, variant }) => (variant ? theme.colors[variant] : theme.colors.primary)} !important;
    }
  }

  & .ant-radio-inner {
    background-color: transparent !important;
    border-width: 2px !important;

    &::after {
      :global {
        width: 6px;
        height: 6px;
        top: 50%;
        left: 50%;
        transform: translate(80%, 80%);
      }
      background-color: ${({ theme, variant }) => (variant ? theme.colors[variant] : theme.colors.primary)} !important;
    }
  }
`

export const Radio = ({ children, ...rest }: RadioProps) => {
  return (
    <ThemeWrapper>
      <StyledRadio {...rest}>{children}</StyledRadio>
    </ThemeWrapper>
  )
}
